var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.html),expression:"html"}],attrs:{"type":"hidden","name":_vm.name},domProps:{"value":(_vm.html)},on:{"input":function($event){if($event.target.composing){ return; }_vm.html=$event.target.value}}}),_vm._v(" "),_c('tinymce',{attrs:{"init":{
      hidden_input: false,
      menubar: false,
      name: _vm.name,
      placeholder: _vm.placeholder,
      plugins: [
         'advlist autolink lists link image charmap print preview anchor',
         'searchreplace visualblocks code fullscreen',
         'insertdatetime media table paste code help wordcount'
       ],
       toolbar:
         "undo redo | bold italic |\n         | link unlink |\n         bullist numlist outdent indent | removeformat"
    },"inline":true},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }